import React from 'react';
import PropTypes from 'prop-types';
import { FormLabel, FormControl, FormControlLabel, Grid, Radio } from '@mui/material';
import { ConfigurationFieldLabel } from '../ConfigurationFieldLabel';
import { CurrentConfigureValue } from '../CurrentConfigureValue';
import { getProcessedStatus } from '../../ChargerConfigurationHelper';

export const labelStyle = {
  fontSize: 13,
  marginBottom: 8,
};

export class ChargerConfigurationRadioField extends React.Component {
  static getDerivedStateFromProps(props, state) {
    if (props.input.value !== state.value) {
      return {
        value: props.input.value,
      };
    }

    return null;
  }

  state = {
    value: this.props.input.value,
  };

  onChange = (event) => {
    const { checked, value } = event.target;

    if (checked) {
      this.props.input.onChange(value);
    } else {
      this.props.input.onChange(null);
    }
    this.props.onFieldChange({ fieldName: this.props.input.name });
  };

  renderOptions = () =>
    this.props.options.map((option) => (
      <FormControlLabel
        key={option.value}
        control={
          <Radio
            checked={this.state.value === option.value}
            value={option.value}
            disabled={this.props.disabled}
            onChange={this.onChange}
            color="primary"
            inputProps={{
              form: this.props.meta.form,
            }}
          />
        }
        label={option.label}
      />
    ));

  render() {
    const {
      label,
      description,
      currentValue,
      status,
      meta: { dirty, touched },
      isBatchUpdate,
      isModal,
    } = this.props;

    const processedStatus = getProcessedStatus(isBatchUpdate ? dirty || touched : dirty, status);

    const wrappedLabel = <ConfigurationFieldLabel label={label} description={description} status={processedStatus} />;

    const currentValueComponent = isBatchUpdate ? (
      this.props.batchUpdateButton(dirty || touched)
    ) : (
      <CurrentConfigureValue dirty={dirty} status={processedStatus} currentValue={currentValue} />
    );

    return (
      <Grid container spacing={2}>
        <Grid item md={6} xs={12}>
          <div className="charger-configuration-checkbox-field">
            <FormControl component="div">
              <FormLabel style={labelStyle}>{wrappedLabel}</FormLabel>
              {this.renderOptions()}
            </FormControl>
            {this.props.clearButton({ processed: processedStatus, actual: status })}
          </div>
        </Grid>
        {!isModal && (
          <Grid item className="current-value-grid-container">
            {currentValueComponent}
          </Grid>
        )}
      </Grid>
    );
  }
}

ChargerConfigurationRadioField.propTypes = {
  label: PropTypes.string,
  options: PropTypes.array,
  meta: PropTypes.object,
  input: PropTypes.object,
  onChange: PropTypes.func,
};
